<template>
  <div class="page-container">
    <div class="doc-wrapper legal-doc">
      <h1 class="main-title">{{ currentTitle }}</h1>
      <div class="meta-info">{{ txt.updated }}</div>
      
      <div class="legal-content">
        <p class="preamble">{{ currentContent.intro }}</p>
        
        <div v-for="(section, index) in currentContent.sections" :key="index" class="clause-box">
          <h3>{{ index + 1 }}. {{ section.title }}</h3>
          <p>{{ section.body }}</p>
        </div>

        <p class="footer-note">{{ currentContent.footer }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import DICT from '../locales/data.js';

export default {
  props: ['type', 'lang'], // type: 'terms' | 'privacy'
  computed: {
    // 获取当前语言包
    txt() { return DICT[this.lang].legal || DICT['en'].legal },
    // 根据 type 获取对应的内容块
    currentContent() { return this.type === 'terms' ? this.txt.terms : this.txt.privacy },
    // 获取标题
    currentTitle() { return this.currentContent.title }
  }
}
</script>

<style scoped>
.page-container { padding: 40px 0 100px; background: #000; min-height: 100vh; color: #ccc; }
.doc-wrapper { max-width: 900px; margin: 0 auto; padding: 40px; background: #0a0b10; border: 1px solid #222; border-radius: 8px; }
.main-title { color: #fff; font-size: 28px; font-weight: 800; margin-bottom: 10px; border-bottom: 1px solid #333; padding-bottom: 20px; }
.meta-info { font-size: 11px; color: #555; margin-bottom: 30px; font-family: monospace; letter-spacing: 1px; }
.preamble { font-size: 14px; color: #fff; margin-bottom: 40px; line-height: 1.6; border-left: 3px solid #00D092; padding-left: 15px; }
.clause-box { margin-bottom: 30px; }
h3 { color: #ddd; font-size: 16px; margin-bottom: 10px; font-weight: 700; }
p { font-size: 13px; color: #888; line-height: 1.8; margin-bottom: 0; text-align: justify; }
.footer-note { margin-top: 50px; padding-top: 20px; border-top: 1px dashed #333; color: #666; font-size: 12px; font-style: italic; text-align: center; }
@media(max-width: 768px) { .doc-wrapper { padding: 20px; border: none; } }
</style>